export default __webpack_public_path__ + "static/media/gteng03.f2bcb765.png";